import { useSelector } from "react-redux";

import { getContentHeight } from "../../../../utils/textUtils";
import useIsMobile from "../../../../hooks/useIsMobile";
import WorkbookCover from "./book/WorkbookCover";
import "./book/BookWorkbookPage.css";

// 일반 내용이해도 들어가면 책 첫 쪽 표지부터(2026-10-25 대표: "내용이해도 첫 페이지 표지"). 원서 워크북 표지 화면
// (BookWorkbookPage 의 isCoverShown)과 같은 틀 · 같은 class 를 쓴다. 표지는 문제지 첫 쪽(assignment.cover_url),
// 없으면 글자 표지.
const ComprehensiveCover = ({ pageCount, hasStarted, onOpen }) => {
  const assignment = useSelector((state) => state.assignment.assignment);
  const isMobile = useIsMobile();
  const coverUrl = assignment?.cover_url || "";
  return (
    <div className="book-workbook book-workbook--ebook" style={{ height: getContentHeight(isMobile) }}>
      <div className="book-workbook__stage">
        {!isMobile && <span className="book-workbook__turn book-workbook__turn--blank" aria-hidden="true" />}
        <div className="book-workbook__spread book-workbook__spread--cover">
          <div
            className="book-workbook__sheet book-workbook__sheet--cover"
            role="button"
            tabIndex={0}
            onClick={onOpen}
            onKeyDown={(event) => (event.key === "Enter" || event.key === " ") && onOpen()}
          >
            <WorkbookCover book={coverUrl ? { cover_url: coverUrl } : {}} title={assignment?.title} />
          </div>
        </div>
        {!isMobile && (
          <button type="button" className="book-workbook__turn" aria-label="책 펼치기" onClick={onOpen}>
            ›
          </button>
        )}
      </div>
      <div className="book-workbook__foot book-workbook__foot--cover">
        {pageCount > 0 && <span className="book-workbook__counter">{pageCount}문항</span>}
        <div className="book-workbook__buttons">
          <button type="button" className="book-workbook__primary" onClick={onOpen}>
            {hasStarted ? "이어서 풀기" : "펼치기"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComprehensiveCover;
